const sanitizeValue = value => {
  switch (typeof value) {
    case 'boolean':
      return value.toString();
    case 'string':
      return value;
    default:
      return Array.isArray(value) ? JSON.stringify(value) : value;
  }
};

const createFormDataFromObject = data => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, sanitizeValue(value) );
  });

  return formData;
};

export default createFormDataFromObject;
